const translations = {
  'en-US': {
    'website_menu': 'Website menu',
    'skills': 'Skills',
    'projects': 'Projects',
    'blog': 'Blog',
    'contact': 'Contact'
  },
  'pt-BR': {
    'website_menu': 'Menu do site',
    'skills': 'Habilidades',
    'projects': 'Projetos',
    'blog': 'Blog',
    'contact': 'Contato'
  }
};

export default translations;
